import { useMemo } from 'react';

import {
   createDynamicColumnsWidth,
   HorizontalAlign,
   JustifyContent,
   TableColumnConfiguration,
} from '@dreryk/react-components';

import { historicalVisitTranslationKeys } from '../../../../translations';
import { NotCopiedPrescriptionSummaryItem } from '../copyPrescription.types';

import { ResultCell } from './cells/ResultCell';
import { CopySummaryRow } from './CopySummaryTable.types';

const t = historicalVisitTranslationKeys.copyPrescription;

type UseCopySummaryTableColumnsOptions = {
   readonly onReplace: (item: NotCopiedPrescriptionSummaryItem) => void;
   readonly notCopiedSummaryItems: readonly NotCopiedPrescriptionSummaryItem[];
};

export const useCopySummaryTableColumns = (
   options: UseCopySummaryTableColumnsOptions
): TableColumnConfiguration<CopySummaryRow>[] => {
   return useMemo(() => {
      const columnsWidths = createDynamicColumnsWidth({ medicineName: '100%', result: '200px' });

      return [
         {
            label: t.columnMedicineName,
            width: columnsWidths.medicineName,
            accessor: 'medicineName',
            sortingDisabled: true,
         },
         {
            name: 'result',
            label: t.columnResult,
            width: columnsWidths.result,
            accessor: 'type',
            justifyContent: JustifyContent.END,
            textAlign: HorizontalAlign.RIGHT,
            renderer: ({ bean }) => (
               <ResultCell
                  copyResult={bean}
                  onReplace={options.onReplace}
                  notCopiedSummaryItems={options.notCopiedSummaryItems}
               />
            ),
            sortingDisabled: true,
         },
      ];
   }, [options.onReplace, options.notCopiedSummaryItems]);
};
